import {ADD_COMPLAIN, RESET_COMPLAIN, UPDATE_COMPLAIN} from "../actions/type";

// const initialState = [];
const initialState ={
    id: null,
    brand_type: "local",
    type: "comment",
    title: "",
    content:"",
    address: "",
    attachment:"",
    is_active: 1,
    status: "new",
    user:null,
    category:null,
    brand:null,
    product:null,
    city:null,
    nsp:null,
    csat:null,
};

export default function complains(state = initialState , action = {}) {
    switch (action.type) {
        case ADD_COMPLAIN :
            const { complain } = action;
            return {
                ...state,
                ...complain
            };
        case UPDATE_COMPLAIN :
            const { comp } = action;
            return {
                ...state,
                ...comp
            };
        case RESET_COMPLAIN :
            return initialState;
        default:
            return state;
    }
};
